import { ActivityStatusResponse } from 'processing-status/activity-status-util';

// activity names/dates are resolved via the mocked useGetActivity, matched by activityId
// not carried on the status objects themselves, matching the real API shape
export const mockActivityStatuses: ActivityStatusResponse[] = [
    {
        activityId: '0',
        status: 'baked', // success tag variant
        modifiedDate: 'Wed. 14.08.2025 at 08:01:01',
    },
    {
        activityId: '1',
        status: 'baked', // success tag variant
        modifiedDate: 'Wed. 14.08.2025 at 20:22:22',
    },
    {
        activityId: '2',
        status: 'baking', // warning tag variant
        modifiedDate: 'Thu. 14.08.2025 at 14:01:01',
    },
    {
        activityId: '3',
        status: 'error:something', // error tag variant
        modifiedDate: 'Thu. 14.08.2025 at 15:01:01',
    },
    {
        activityId: '4',
        status: 'baked 0-11-11', // success tag variant
        modifiedDate: 'Thu. 15.08.2025 at 14:01:01',
    },
    {
        activityId: '5',
        status: 'baked 2-9-11', // error tag variant
        modifiedDate: 'Thu. 15.08.2025 at 14:31:01',
    },
    {
        activityId: '6',
        status: 'error:no PIP', // error tag variant
        modifiedDate: 'Thu. 15.08.2025 at 15:01:01',
    },
    {
        activityId: '7',
        status: 'error:no files synced', // error tag variant
        modifiedDate: 'Thu. 15.08.2025 at 15:31:01',
    },
];

export const MOCK_ATHLETES_LIST = [{ id: 'ath1' }, { id: 'ath2' }, { id: 'ath3' }, { id: 'ath4' }];

// these are the activity athletes for the 3 activities used for mock statuses, as returned by the API
// we can then use their ids in the mock athlete statuses, so we match the actual activity athletes in the components
// The first 3 entries are full objects (matching API shape); the remaining 12 are compact (only `id` is needed
// by generateMockAthleteStatuses — full athlete data is fetched live via useGetAthletesInActivity)
export const athletesByActivity: Record<string, Array<{ id: string } & Record<string, unknown>>>[] = [
    {
        // Friendly Match 5
        '34ca0a39-cc6a-4a2a-ad79-9c0316c5139f': [
            {
                id: '5deb19d4-87a6-4f5a-9605-1eb0217db907',
                first_name: 'Colin',
                last_name: 'Cravat',
                gender: null,
                jersey: 'CCr',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 205,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:10:55',
                modified_at: '2025-07-23 15:37:25',
                activity_athlete_id: '16ff282d-3a05-4d65-ab7c-ef282c93a4e2',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'W',
                position_id: '3b8082d6-ad8b-11e4-b909-06f135e73482',
                position_name: '4. Winger',
            },
            {
                id: 'c998cdf8-9e42-4112-89e3-09d07fa454a7',
                first_name: 'Trevor',
                last_name: 'Cremier',
                gender: null,
                jersey: 'TC',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 195,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:10:25',
                modified_at: '2023-01-20 12:10:05',
                activity_athlete_id: '40ad76d7-5246-4e89-aa70-351e3fbd778b',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'CM',
                position_id: '3b7a5622-ad8b-11e4-b909-06f135e73482',
                position_name: '3. Central Midfielder',
            },
            {
                id: 'f80845e8-af1b-45b8-a861-19a94574b318',
                first_name: 'Dean',
                last_name: 'Davis',
                gender: null,
                jersey: 'DD',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 195,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:11:11',
                modified_at: '2025-10-17 12:33:06',
                activity_athlete_id: '20532898-fdb8-4042-bd5d-6b0cd26b8896',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Part'],
                tags: [
                    {
                        id: 'dcef9d25-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Part',
                        tag_type_name: 'Participation',
                        tag_name: 'Part',
                    },
                ],
                position: 'CM',
                position_id: '3b7a5622-ad8b-11e4-b909-06f135e73482',
                position_name: '3. Central Midfielder',
            },
            {
                id: '9959665d-557c-42f7-a663-7dba9b467535',
                first_name: 'Chris',
                last_name: 'Edwards',
                gender: null,
                jersey: 'CE',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 202,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:11:31',
                modified_at: '2023-01-20 12:10:05',
                activity_athlete_id: '09767a5e-07ac-4117-b9b5-972164de5950',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Part'],
                tags: [
                    {
                        id: 'dcef9d25-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Part',
                        tag_type_name: 'Participation',
                        tag_name: 'Part',
                    },
                ],
                position: 'CM',
                position_id: '3b7a5622-ad8b-11e4-b909-06f135e73482',
                position_name: '3. Central Midfielder',
            },
            {
                id: 'eedbd8d6-12a0-4e67-aabb-3d87580ef207',
                first_name: 'Andrew',
                last_name: 'Harris',
                gender: null,
                jersey: 'AHa',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 209,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:12:33',
                modified_at: '2023-01-20 12:10:06',
                activity_athlete_id: '12adcc4d-b59c-43a6-8153-8e256396ef73',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Part'],
                tags: [
                    {
                        id: 'dcef9d25-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Part',
                        tag_type_name: 'Participation',
                        tag_name: 'Part',
                    },
                ],
                position: 'FB',
                position_id: '3b6fc040-ad8b-11e4-b909-06f135e73482',
                position_name: '2. Full Back',
            },
            {
                id: '44e2c2fd-0f60-4c71-9e0a-abd867350d48',
                first_name: 'Gary',
                last_name: 'Heyworth',
                gender: null,
                jersey: 'GH',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 209,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:12:11',
                modified_at: '2025-10-17 14:47:29',
                activity_athlete_id: 'b05941ba-86c0-44ca-99d1-b39cd7773acc',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'CB',
                position_id: '3b7103b3-ad8b-11e4-b909-06f135e73482',
                position_name: '1. Centre Back',
            },
            {
                id: 'a552bbdf-8777-4b60-abe3-85f88a0a3b0e',
                first_name: 'Martyn',
                last_name: 'Kevin',
                gender: null,
                jersey: 'MK',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 213,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:12:57',
                modified_at: '2023-01-20 12:10:06',
                activity_athlete_id: '49a98d03-a91b-4373-babf-611932471d83',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'CB',
                position_id: '3b7103b3-ad8b-11e4-b909-06f135e73482',
                position_name: '1. Centre Back',
            },
            {
                id: 'ec51cb4d-5a92-4bf4-84fb-a6cab53ab9b6',
                first_name: 'Jeremy',
                last_name: 'Kline',
                gender: null,
                jersey: 'JK',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 210,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:13:20',
                modified_at: '2023-01-20 12:10:06',
                activity_athlete_id: '6d41ae4e-f4c1-430d-859e-af34e3ef6437',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'W',
                position_id: '3b8082d6-ad8b-11e4-b909-06f135e73482',
                position_name: '4. Winger',
            },
            {
                id: '4da15fb0-baac-4cf9-bca3-af7de054a35a',
                first_name: 'James',
                last_name: 'Leavin',
                gender: null,
                jersey: 'JL',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 202,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:13:44',
                modified_at: '2025-10-17 12:32:51',
                activity_athlete_id: 'a093eb5b-65e6-4744-b77e-a7c84d7abbd8',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'CM',
                position_id: '3b7a5622-ad8b-11e4-b909-06f135e73482',
                position_name: '3. Central Midfielder',
            },
            {
                id: 'eaf87493-0db9-4f15-958a-bfe4d67964a6',
                first_name: 'Jackson',
                last_name: 'Right',
                gender: null,
                jersey: 'JR',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 202,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:14:57',
                modified_at: '2025-10-17 12:33:47',
                activity_athlete_id: 'c2091023-0356-4261-b9c5-805884c01fd0',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'Att',
                position_id: '3b869e2c-ad8b-11e4-b909-06f135e73482',
                position_name: '5. Attacker',
            },
            {
                id: '5902cf28-3f1f-435d-b164-08e4d51ce944',
                first_name: 'Travis',
                last_name: 'Spot',
                gender: null,
                jersey: 'TSp',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 199,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:17:24',
                modified_at: '2023-01-20 12:10:08',
                activity_athlete_id: '2e4326a2-ff8a-47b1-a95f-06bd6758d089',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Part'],
                tags: [
                    {
                        id: 'dcef9d25-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Part',
                        tag_type_name: 'Participation',
                        tag_name: 'Part',
                    },
                ],
                position: 'FB',
                position_id: '3b6fc040-ad8b-11e4-b909-06f135e73482',
                position_name: '2. Full Back',
            },
            {
                id: '26206ff9-8cd2-4f34-af95-f083aa74d339',
                first_name: 'Leon',
                last_name: 'Williams',
                gender: null,
                jersey: 'LW',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 201,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:43:25',
                modified_at: '2023-01-20 12:10:08',
                activity_athlete_id: '844235d3-822e-42b1-9d18-d0de146a3e70',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Part'],
                tags: [
                    {
                        id: 'dcef9d25-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Part',
                        tag_type_name: 'Participation',
                        tag_name: 'Part',
                    },
                ],
                position: 'CM',
                position_id: '3b7a5622-ad8b-11e4-b909-06f135e73482',
                position_name: '3. Central Midfielder',
            },
        ],
    },
    // Friendly Match 4
    {
        '5aee6b26-768d-45ff-bdd3-669d0b8f19f7': [
            {
                id: '9a9a6431-4f54-4935-a53c-d8663970b79d',
                first_name: 'Alexander',
                last_name: 'Babeyaro',
                gender: null,
                jersey: 'AB',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 211,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:08:53',
                modified_at: '2025-10-20 14:13:30',
                activity_athlete_id: '55b300f6-f8de-41d0-bb6b-0ab51431d5d4',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'FB',
                position_id: '3b6fc040-ad8b-11e4-b909-06f135e73482',
                position_name: '2. Full Back',
            },
            {
                id: 'f80845e8-af1b-45b8-a861-19a94574b318',
                first_name: 'Dean',
                last_name: 'Davis',
                gender: null,
                jersey: 'DD',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 195,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:11:11',
                modified_at: '2025-10-17 12:33:06',
                activity_athlete_id: 'f615ab78-a0d6-4808-a283-0613cb246827',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Part'],
                tags: [
                    {
                        id: 'dcef9d25-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Part',
                        tag_type_name: 'Participation',
                        tag_name: 'Part',
                    },
                ],
                position: 'CM',
                position_id: '3b7a5622-ad8b-11e4-b909-06f135e73482',
                position_name: '3. Central Midfielder',
            },
            {
                id: '9959665d-557c-42f7-a663-7dba9b467535',
                first_name: 'Chris',
                last_name: 'Edwards',
                gender: null,
                jersey: 'CE',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 202,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:11:31',
                modified_at: '2023-01-20 12:10:05',
                activity_athlete_id: '9e04a41c-e46c-4e3e-afd8-91551fc5e01e',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Part'],
                tags: [
                    {
                        id: 'dcef9d25-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Part',
                        tag_type_name: 'Participation',
                        tag_name: 'Part',
                    },
                ],
                position: 'CM',
                position_id: '3b7a5622-ad8b-11e4-b909-06f135e73482',
                position_name: '3. Central Midfielder',
            },
            {
                id: 'eedbd8d6-12a0-4e67-aabb-3d87580ef207',
                first_name: 'Andrew',
                last_name: 'Harris',
                gender: null,
                jersey: 'AHa',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 209,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:12:33',
                modified_at: '2023-01-20 12:10:06',
                activity_athlete_id: 'db80cfd7-8a0c-4ef0-9925-85b38c6423ff',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Part'],
                tags: [
                    {
                        id: 'dcef9d25-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Part',
                        tag_type_name: 'Participation',
                        tag_name: 'Part',
                    },
                ],
                position: 'FB',
                position_id: '3b6fc040-ad8b-11e4-b909-06f135e73482',
                position_name: '2. Full Back',
            },
            {
                id: '44e2c2fd-0f60-4c71-9e0a-abd867350d48',
                first_name: 'Gary',
                last_name: 'Heyworth',
                gender: null,
                jersey: 'GH',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 209,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:12:11',
                modified_at: '2025-10-17 14:47:29',
                activity_athlete_id: '04f7aef1-b7c8-4842-864a-30081a8cd816',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'CB',
                position_id: '3b7103b3-ad8b-11e4-b909-06f135e73482',
                position_name: '1. Centre Back',
            },
            {
                id: 'a552bbdf-8777-4b60-abe3-85f88a0a3b0e',
                first_name: 'Martyn',
                last_name: 'Kevin',
                gender: null,
                jersey: 'MK',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 213,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:12:57',
                modified_at: '2023-01-20 12:10:06',
                activity_athlete_id: 'b5ac2260-08d2-48be-adde-c561cf9c57a4',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'CB',
                position_id: '3b7103b3-ad8b-11e4-b909-06f135e73482',
                position_name: '1. Centre Back',
            },
            {
                id: 'ec51cb4d-5a92-4bf4-84fb-a6cab53ab9b6',
                first_name: 'Jeremy',
                last_name: 'Kline',
                gender: null,
                jersey: 'JK',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 210,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:13:20',
                modified_at: '2023-01-20 12:10:06',
                activity_athlete_id: '50eb5a06-4ec9-45c8-bc4b-3dcdaf07f1fd',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'W',
                position_id: '3b8082d6-ad8b-11e4-b909-06f135e73482',
                position_name: '4. Winger',
            },
            {
                id: '4da15fb0-baac-4cf9-bca3-af7de054a35a',
                first_name: 'James',
                last_name: 'Leavin',
                gender: null,
                jersey: 'JL',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 202,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:13:44',
                modified_at: '2025-10-17 12:32:51',
                activity_athlete_id: 'e0e0d35d-0af5-48e4-bf06-a72d1e7bd6ff',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'CM',
                position_id: '3b7a5622-ad8b-11e4-b909-06f135e73482',
                position_name: '3. Central Midfielder',
            },
            {
                id: '2655a736-9aab-468b-93b9-c745d072c34e',
                first_name: 'Bob',
                last_name: 'Murray',
                gender: null,
                jersey: 'BMu',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 205,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:14:08',
                modified_at: '2023-01-20 12:10:07',
                activity_athlete_id: 'c172a3fd-4552-43d8-83d2-9db668408af2',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'W',
                position_id: '3b8082d6-ad8b-11e4-b909-06f135e73482',
                position_name: '4. Winger',
            },
            {
                id: '5902cf28-3f1f-435d-b164-08e4d51ce944',
                first_name: 'Travis',
                last_name: 'Spot',
                gender: null,
                jersey: 'TSp',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 199,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:17:24',
                modified_at: '2023-01-20 12:10:08',
                activity_athlete_id: 'c91cde3e-644b-45ed-8119-1265a59224bf',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'FB',
                position_id: '3b6fc040-ad8b-11e4-b909-06f135e73482',
                position_name: '2. Full Back',
            },
            {
                id: 'd8b70be7-576d-4a8d-ab10-b30576a00037',
                first_name: 'Curtis',
                last_name: 'Trebor',
                gender: null,
                jersey: 'CT',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 201,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:18:00',
                modified_at: '2025-10-17 14:46:41',
                activity_athlete_id: '26aa1e23-76e7-4335-819f-31f8743e7fb6',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'W',
                position_id: '3b8082d6-ad8b-11e4-b909-06f135e73482',
                position_name: '4. Winger',
            },
            {
                id: '7c05f740-720c-42aa-99d1-0cf9dc0c33ea',
                first_name: 'Liam',
                last_name: 'Veron',
                gender: null,
                jersey: 'LV',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 197,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:42:56',
                modified_at: '2023-01-20 12:10:08',
                activity_athlete_id: '03a57a55-e3ec-4297-9ce3-b752f51d3a63',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Part'],
                tags: [
                    {
                        id: 'dcef9d25-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Part',
                        tag_type_name: 'Participation',
                        tag_name: 'Part',
                    },
                ],
                position: 'Att',
                position_id: '3b869e2c-ad8b-11e4-b909-06f135e73482',
                position_name: '5. Attacker',
            },
            {
                id: '26206ff9-8cd2-4f34-af95-f083aa74d339',
                first_name: 'Leon',
                last_name: 'Williams',
                gender: null,
                jersey: 'LW',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 201,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:43:25',
                modified_at: '2023-01-20 12:10:08',
                activity_athlete_id: 'af6c887f-1214-48c5-a3b6-9b4c6c533b21',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'CM',
                position_id: '3b7a5622-ad8b-11e4-b909-06f135e73482',
                position_name: '3. Central Midfielder',
            },
        ],
    },
    // Friendly Match 3 — note: this activity is hidden from modal in dev (see activity-status-element.tsx)
    {
        '7f00b666-f5b6-4110-b4e3-6b1f81e26876': [
            {
                id: '9a9a6431-4f54-4935-a53c-d8663970b79d',
                first_name: 'Alexander',
                last_name: 'Babeyaro',
                gender: null,
                jersey: 'AB',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 211,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:08:53',
                modified_at: '2025-10-20 14:13:30',
                activity_athlete_id: '757dc17a-ea93-4fbc-b504-34c3356bad25',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'FB',
                position_id: '3b6fc040-ad8b-11e4-b909-06f135e73482',
                position_name: '2. Full Back',
            },
            {
                id: '5deb19d4-87a6-4f5a-9605-1eb0217db907',
                first_name: 'Colin',
                last_name: 'Cravat',
                gender: null,
                jersey: 'CCr',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 205,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:10:55',
                modified_at: '2025-07-23 15:37:25',
                activity_athlete_id: '1a9179b3-31eb-4706-b959-eb933bd72f20',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'W',
                position_id: '3b8082d6-ad8b-11e4-b909-06f135e73482',
                position_name: '4. Winger',
            },
            {
                id: 'c998cdf8-9e42-4112-89e3-09d07fa454a7',
                first_name: 'Trevor',
                last_name: 'Cremier',
                gender: null,
                jersey: 'TC',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 195,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:10:25',
                modified_at: '2023-01-20 12:10:05',
                activity_athlete_id: '24bad535-8a31-4326-ac24-a83bbad01e7c',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'CM',
                position_id: '3b7a5622-ad8b-11e4-b909-06f135e73482',
                position_name: '3. Central Midfielder',
            },
            {
                id: 'f80845e8-af1b-45b8-a861-19a94574b318',
                first_name: 'Dean',
                last_name: 'Davis',
                gender: null,
                jersey: 'DD',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 195,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:11:11',
                modified_at: '2025-10-17 12:33:06',
                activity_athlete_id: '434dc377-0461-4881-8da5-508894da724e',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'CM',
                position_id: '3b7a5622-ad8b-11e4-b909-06f135e73482',
                position_name: '3. Central Midfielder',
            },
            {
                id: '9959665d-557c-42f7-a663-7dba9b467535',
                first_name: 'Chris',
                last_name: 'Edwards',
                gender: null,
                jersey: 'CE',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 202,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:11:31',
                modified_at: '2023-01-20 12:10:05',
                activity_athlete_id: 'badea5ab-a4b6-4ca7-a5ca-cd7965742a3d',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'CM',
                position_id: '3b7a5622-ad8b-11e4-b909-06f135e73482',
                position_name: '3. Central Midfielder',
            },
            {
                id: '44e2c2fd-0f60-4c71-9e0a-abd867350d48',
                first_name: 'Gary',
                last_name: 'Heyworth',
                gender: null,
                jersey: 'GH',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 209,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:12:11',
                modified_at: '2025-10-17 14:47:29',
                activity_athlete_id: '05c75d7f-b3e8-42f7-8655-16155843c53c',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'CB',
                position_id: '3b7103b3-ad8b-11e4-b909-06f135e73482',
                position_name: '1. Centre Back',
            },
            {
                id: 'a552bbdf-8777-4b60-abe3-85f88a0a3b0e',
                first_name: 'Martyn',
                last_name: 'Kevin',
                gender: null,
                jersey: 'MK',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 213,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:12:57',
                modified_at: '2023-01-20 12:10:06',
                activity_athlete_id: '779c2dc4-ff26-49d9-bcca-4a696b8bf060',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'CB',
                position_id: '3b7103b3-ad8b-11e4-b909-06f135e73482',
                position_name: '1. Centre Back',
            },
            {
                id: 'ec51cb4d-5a92-4bf4-84fb-a6cab53ab9b6',
                first_name: 'Jeremy',
                last_name: 'Kline',
                gender: null,
                jersey: 'JK',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 210,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:13:20',
                modified_at: '2023-01-20 12:10:06',
                activity_athlete_id: 'd932ae23-ea6a-4129-a60f-6af12963ac5c',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'W',
                position_id: '3b8082d6-ad8b-11e4-b909-06f135e73482',
                position_name: '4. Winger',
            },
            {
                id: 'eaf87493-0db9-4f15-958a-bfe4d67964a6',
                first_name: 'Jackson',
                last_name: 'Right',
                gender: null,
                jersey: 'JR',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 202,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:14:57',
                modified_at: '2025-10-17 12:33:47',
                activity_athlete_id: '623aac34-978a-4864-a4e0-3adf1f7c84b7',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'Att',
                position_id: '3b869e2c-ad8b-11e4-b909-06f135e73482',
                position_name: '5. Attacker',
            },
            {
                id: '7c05f740-720c-42aa-99d1-0cf9dc0c33ea',
                first_name: 'Liam',
                last_name: 'Veron',
                gender: null,
                jersey: 'LV',
                nickname: '',
                height: 180,
                weight: 80,
                date_of_birth: -3600,
                velocity_max: 10,
                acceleration_max: 0,
                heart_rate_max: 197,
                player_load_max: 0,
                image: '',
                icon: 'circle',
                stroke_colour: '#000000',
                fill_colour: '#c42828',
                trail_colour_start: '',
                trail_colour_end: '',
                is_synced: 0,
                is_deleted: 0,
                created_at: '2016-10-25 14:42:56',
                modified_at: '2023-01-20 12:10:08',
                activity_athlete_id: 'ff8de9f9-9c15-4294-a7eb-db32c007cb1a',
                date_of_birth_date: '1970-01-01',
                tag_list: ['Full'],
                tags: [
                    {
                        id: 'dce820a7-709f-11e8-a462-06eefb329890',
                        tag_type_id: 'dcd4bc3f-709f-11e8-a462-06eefb329890',
                        name: 'Full',
                        tag_type_name: 'Participation',
                        tag_name: 'Full',
                    },
                ],
                position: 'Att',
                position_id: '3b869e2c-ad8b-11e4-b909-06f135e73482',
                position_name: '5. Attacker',
            },
        ],
    },
    // Activities 4-22: compact entries for pagination testing (only id needed by mock generator)
    // All athlete IDs are real — same 16 athletes as above, in different subsets per activity
    {
        '9a1122a0-27ae-474c-8796-56a9d3028672': [
            { id: '5deb19d4-87a6-4f5a-9605-1eb0217db907' },
            { id: 'f80845e8-af1b-45b8-a861-19a94574b318' },
            { id: '9959665d-557c-42f7-a663-7dba9b467535' },
            { id: '44e2c2fd-0f60-4c71-9e0a-abd867350d48' },
            { id: 'a552bbdf-8777-4b60-abe3-85f88a0a3b0e' },
            { id: 'ec51cb4d-5a92-4bf4-84fb-a6cab53ab9b6' },
            { id: '4da15fb0-baac-4cf9-bca3-af7de054a35a' },
            { id: 'eaf87493-0db9-4f15-958a-bfe4d67964a6' },
            { id: '5902cf28-3f1f-435d-b164-08e4d51ce944' },
            { id: '26206ff9-8cd2-4f34-af95-f083aa74d339' },
        ],
    },
    {
        'bb7b3894-1b4d-4bb7-a35c-eb0ca3a596e3': [
            { id: 'c998cdf8-9e42-4112-89e3-09d07fa454a7' },
            { id: 'eedbd8d6-12a0-4e67-aabb-3d87580ef207' },
            { id: '9a9a6431-4f54-4935-a53c-d8663970b79d' },
            { id: '2655a736-9aab-468b-93b9-c745d072c34e' },
            { id: 'd8b70be7-576d-4a8d-ab10-b30576a00037' },
            { id: '7c05f740-720c-42aa-99d1-0cf9dc0c33ea' },
            { id: '5deb19d4-87a6-4f5a-9605-1eb0217db907' },
            { id: 'ec51cb4d-5a92-4bf4-84fb-a6cab53ab9b6' },
        ],
    },
    {
        '3f59528e-6063-4f2e-a6fd-aeb232a66b66': [
            { id: '9a9a6431-4f54-4935-a53c-d8663970b79d' },
            { id: '26206ff9-8cd2-4f34-af95-f083aa74d339' },
            { id: '7c05f740-720c-42aa-99d1-0cf9dc0c33ea' },
            { id: '2655a736-9aab-468b-93b9-c745d072c34e' },
            { id: 'f80845e8-af1b-45b8-a861-19a94574b318' },
            { id: 'eaf87493-0db9-4f15-958a-bfe4d67964a6' },
            { id: '5902cf28-3f1f-435d-b164-08e4d51ce944' },
            { id: 'd8b70be7-576d-4a8d-ab10-b30576a00037' },
            { id: 'a552bbdf-8777-4b60-abe3-85f88a0a3b0e' },
        ],
    },
    {
        '7728034b-3d8f-4940-924d-2cb826bec330': [
            { id: '5deb19d4-87a6-4f5a-9605-1eb0217db907' },
            { id: 'c998cdf8-9e42-4112-89e3-09d07fa454a7' },
            { id: '9959665d-557c-42f7-a663-7dba9b467535' },
            { id: 'eedbd8d6-12a0-4e67-aabb-3d87580ef207' },
            { id: '44e2c2fd-0f60-4c71-9e0a-abd867350d48' },
            { id: '4da15fb0-baac-4cf9-bca3-af7de054a35a' },
            { id: '26206ff9-8cd2-4f34-af95-f083aa74d339' },
            { id: '7c05f740-720c-42aa-99d1-0cf9dc0c33ea' },
            { id: 'ec51cb4d-5a92-4bf4-84fb-a6cab53ab9b6' },
            { id: 'd8b70be7-576d-4a8d-ab10-b30576a00037' },
            { id: '2655a736-9aab-468b-93b9-c745d072c34e' },
        ],
    },
    {
        '19e09e74-59ac-48fd-ad86-9b08079da321': [
            { id: 'a552bbdf-8777-4b60-abe3-85f88a0a3b0e' },
            { id: 'ec51cb4d-5a92-4bf4-84fb-a6cab53ab9b6' },
            { id: '4da15fb0-baac-4cf9-bca3-af7de054a35a' },
            { id: 'eaf87493-0db9-4f15-958a-bfe4d67964a6' },
            { id: '9a9a6431-4f54-4935-a53c-d8663970b79d' },
            { id: '5902cf28-3f1f-435d-b164-08e4d51ce944' },
            { id: 'f80845e8-af1b-45b8-a861-19a94574b318' },
            { id: 'eedbd8d6-12a0-4e67-aabb-3d87580ef207' },
        ],
    },
    {
        '8a085a9d-7e17-4205-b090-d9c7153443bb': [
            { id: '9a9a6431-4f54-4935-a53c-d8663970b79d' },
            { id: 'd8b70be7-576d-4a8d-ab10-b30576a00037' },
            { id: '5902cf28-3f1f-435d-b164-08e4d51ce944' },
            { id: '26206ff9-8cd2-4f34-af95-f083aa74d339' },
            { id: '7c05f740-720c-42aa-99d1-0cf9dc0c33ea' },
            { id: '5deb19d4-87a6-4f5a-9605-1eb0217db907' },
            { id: 'c998cdf8-9e42-4112-89e3-09d07fa454a7' },
            { id: '9959665d-557c-42f7-a663-7dba9b467535' },
            { id: '44e2c2fd-0f60-4c71-9e0a-abd867350d48' },
            { id: 'a552bbdf-8777-4b60-abe3-85f88a0a3b0e' },
            { id: '2655a736-9aab-468b-93b9-c745d072c34e' },
            { id: 'eaf87493-0db9-4f15-958a-bfe4d67964a6' },
        ],
    },
    {
        'b190e4a3-a0c9-4877-91bf-78edb5abe00b': [
            { id: 'f80845e8-af1b-45b8-a861-19a94574b318' },
            { id: 'eedbd8d6-12a0-4e67-aabb-3d87580ef207' },
            { id: '2655a736-9aab-468b-93b9-c745d072c34e' },
            { id: 'ec51cb4d-5a92-4bf4-84fb-a6cab53ab9b6' },
            { id: '4da15fb0-baac-4cf9-bca3-af7de054a35a' },
            { id: '9959665d-557c-42f7-a663-7dba9b467535' },
            { id: '7c05f740-720c-42aa-99d1-0cf9dc0c33ea' },
            { id: '26206ff9-8cd2-4f34-af95-f083aa74d339' },
            { id: 'd8b70be7-576d-4a8d-ab10-b30576a00037' },
            { id: '5902cf28-3f1f-435d-b164-08e4d51ce944' },
        ],
    },
    {
        'efdab5ad-b250-4f7a-bd58-29d3dccee66e': [
            { id: '5deb19d4-87a6-4f5a-9605-1eb0217db907' },
            { id: 'c998cdf8-9e42-4112-89e3-09d07fa454a7' },
            { id: '9959665d-557c-42f7-a663-7dba9b467535' },
            { id: '44e2c2fd-0f60-4c71-9e0a-abd867350d48' },
            { id: 'eaf87493-0db9-4f15-958a-bfe4d67964a6' },
            { id: '9a9a6431-4f54-4935-a53c-d8663970b79d' },
            { id: '2655a736-9aab-468b-93b9-c745d072c34e' },
            { id: 'eedbd8d6-12a0-4e67-aabb-3d87580ef207' },
        ],
    },
    {
        'fe1b68ea-c2fc-4fa4-8ccc-2a75c2039d29': [
            { id: '9a9a6431-4f54-4935-a53c-d8663970b79d' },
            { id: 'a552bbdf-8777-4b60-abe3-85f88a0a3b0e' },
            { id: '4da15fb0-baac-4cf9-bca3-af7de054a35a' },
            { id: '7c05f740-720c-42aa-99d1-0cf9dc0c33ea' },
            { id: '26206ff9-8cd2-4f34-af95-f083aa74d339' },
            { id: 'f80845e8-af1b-45b8-a861-19a94574b318' },
            { id: '5902cf28-3f1f-435d-b164-08e4d51ce944' },
            { id: 'ec51cb4d-5a92-4bf4-84fb-a6cab53ab9b6' },
            { id: 'd8b70be7-576d-4a8d-ab10-b30576a00037' },
            { id: 'c998cdf8-9e42-4112-89e3-09d07fa454a7' },
            { id: 'eaf87493-0db9-4f15-958a-bfe4d67964a6' },
        ],
    },
    {
        'dd0d9fb0-2bd7-4d95-ad79-1a3911fab84d': [
            { id: 'f80845e8-af1b-45b8-a861-19a94574b318' },
            { id: 'eaf87493-0db9-4f15-958a-bfe4d67964a6' },
            { id: '5902cf28-3f1f-435d-b164-08e4d51ce944' },
            { id: 'd8b70be7-576d-4a8d-ab10-b30576a00037' },
            { id: '44e2c2fd-0f60-4c71-9e0a-abd867350d48' },
            { id: 'eedbd8d6-12a0-4e67-aabb-3d87580ef207' },
            { id: '2655a736-9aab-468b-93b9-c745d072c34e' },
            { id: '9959665d-557c-42f7-a663-7dba9b467535' },
            { id: 'a552bbdf-8777-4b60-abe3-85f88a0a3b0e' },
        ],
    },
    {
        '750503be-76a6-4850-824d-dad0211960c7': [
            { id: 'eedbd8d6-12a0-4e67-aabb-3d87580ef207' },
            { id: 'ec51cb4d-5a92-4bf4-84fb-a6cab53ab9b6' },
            { id: '2655a736-9aab-468b-93b9-c745d072c34e' },
            { id: '44e2c2fd-0f60-4c71-9e0a-abd867350d48' },
            { id: 'a552bbdf-8777-4b60-abe3-85f88a0a3b0e' },
            { id: '5deb19d4-87a6-4f5a-9605-1eb0217db907' },
            { id: 'c998cdf8-9e42-4112-89e3-09d07fa454a7' },
            { id: '26206ff9-8cd2-4f34-af95-f083aa74d339' },
            { id: '9a9a6431-4f54-4935-a53c-d8663970b79d' },
            { id: '4da15fb0-baac-4cf9-bca3-af7de054a35a' },
            { id: '7c05f740-720c-42aa-99d1-0cf9dc0c33ea' },
            { id: 'f80845e8-af1b-45b8-a861-19a94574b318' },
        ],
    },
    {
        'c019c42b-b59a-41f1-ae01-6ebf2ff83546': [
            { id: '9a9a6431-4f54-4935-a53c-d8663970b79d' },
            { id: '5deb19d4-87a6-4f5a-9605-1eb0217db907' },
            { id: 'c998cdf8-9e42-4112-89e3-09d07fa454a7' },
            { id: '7c05f740-720c-42aa-99d1-0cf9dc0c33ea' },
            { id: '26206ff9-8cd2-4f34-af95-f083aa74d339' },
            { id: 'd8b70be7-576d-4a8d-ab10-b30576a00037' },
            { id: 'eaf87493-0db9-4f15-958a-bfe4d67964a6' },
            { id: '9959665d-557c-42f7-a663-7dba9b467535' },
            { id: 'ec51cb4d-5a92-4bf4-84fb-a6cab53ab9b6' },
            { id: '5902cf28-3f1f-435d-b164-08e4d51ce944' },
        ],
    },
    {
        'f924d11d-0d9a-4204-b60b-61ada0c95231': [
            { id: '5deb19d4-87a6-4f5a-9605-1eb0217db907' },
            { id: 'f80845e8-af1b-45b8-a861-19a94574b318' },
            { id: 'a552bbdf-8777-4b60-abe3-85f88a0a3b0e' },
            { id: 'eedbd8d6-12a0-4e67-aabb-3d87580ef207' },
            { id: '2655a736-9aab-468b-93b9-c745d072c34e' },
            { id: '4da15fb0-baac-4cf9-bca3-af7de054a35a' },
            { id: '9959665d-557c-42f7-a663-7dba9b467535' },
            { id: '26206ff9-8cd2-4f34-af95-f083aa74d339' },
            { id: 'd8b70be7-576d-4a8d-ab10-b30576a00037' },
        ],
    },
    {
        'd2c7aa65-4a99-417f-b46e-1f07722164ca': [
            { id: 'c998cdf8-9e42-4112-89e3-09d07fa454a7' },
            { id: '44e2c2fd-0f60-4c71-9e0a-abd867350d48' },
            { id: 'ec51cb4d-5a92-4bf4-84fb-a6cab53ab9b6' },
            { id: '9a9a6431-4f54-4935-a53c-d8663970b79d' },
            { id: 'eaf87493-0db9-4f15-958a-bfe4d67964a6' },
            { id: '7c05f740-720c-42aa-99d1-0cf9dc0c33ea' },
            { id: '5902cf28-3f1f-435d-b164-08e4d51ce944' },
            { id: 'a552bbdf-8777-4b60-abe3-85f88a0a3b0e' },
            { id: '9959665d-557c-42f7-a663-7dba9b467535' },
            { id: '26206ff9-8cd2-4f34-af95-f083aa74d339' },
        ],
    },
    {
        '84d46820-8c24-4ee2-9c2e-c8c87c0b644e': [
            { id: 'eedbd8d6-12a0-4e67-aabb-3d87580ef207' },
            { id: 'f80845e8-af1b-45b8-a861-19a94574b318' },
            { id: 'd8b70be7-576d-4a8d-ab10-b30576a00037' },
            { id: '4da15fb0-baac-4cf9-bca3-af7de054a35a' },
            { id: '2655a736-9aab-468b-93b9-c745d072c34e' },
            { id: '5deb19d4-87a6-4f5a-9605-1eb0217db907' },
            { id: '44e2c2fd-0f60-4c71-9e0a-abd867350d48' },
            { id: 'c998cdf8-9e42-4112-89e3-09d07fa454a7' },
        ],
    },
    {
        '23f114f8-f770-4a93-afd3-b4f25503fcc4': [
            { id: 'a552bbdf-8777-4b60-abe3-85f88a0a3b0e' },
            { id: '9a9a6431-4f54-4935-a53c-d8663970b79d' },
            { id: 'ec51cb4d-5a92-4bf4-84fb-a6cab53ab9b6' },
            { id: 'eaf87493-0db9-4f15-958a-bfe4d67964a6' },
            { id: '7c05f740-720c-42aa-99d1-0cf9dc0c33ea' },
            { id: '26206ff9-8cd2-4f34-af95-f083aa74d339' },
            { id: '9959665d-557c-42f7-a663-7dba9b467535' },
            { id: 'eedbd8d6-12a0-4e67-aabb-3d87580ef207' },
            { id: '5902cf28-3f1f-435d-b164-08e4d51ce944' },
            { id: 'f80845e8-af1b-45b8-a861-19a94574b318' },
            { id: '44e2c2fd-0f60-4c71-9e0a-abd867350d48' },
        ],
    },
    {
        'ad6a108e-b1c1-4892-80b1-3620809aca76': [
            { id: '5deb19d4-87a6-4f5a-9605-1eb0217db907' },
            { id: '9959665d-557c-42f7-a663-7dba9b467535' },
            { id: 'a552bbdf-8777-4b60-abe3-85f88a0a3b0e' },
            { id: 'c998cdf8-9e42-4112-89e3-09d07fa454a7' },
            { id: '2655a736-9aab-468b-93b9-c745d072c34e' },
            { id: 'd8b70be7-576d-4a8d-ab10-b30576a00037' },
            { id: '26206ff9-8cd2-4f34-af95-f083aa74d339' },
            { id: '4da15fb0-baac-4cf9-bca3-af7de054a35a' },
            { id: 'eaf87493-0db9-4f15-958a-bfe4d67964a6' },
        ],
    },
    {
        'bd78e800-4f91-4c38-a2f0-efc83c59c297': [
            { id: 'f80845e8-af1b-45b8-a861-19a94574b318' },
            { id: '44e2c2fd-0f60-4c71-9e0a-abd867350d48' },
            { id: '9a9a6431-4f54-4935-a53c-d8663970b79d' },
            { id: 'eedbd8d6-12a0-4e67-aabb-3d87580ef207' },
            { id: 'ec51cb4d-5a92-4bf4-84fb-a6cab53ab9b6' },
            { id: '7c05f740-720c-42aa-99d1-0cf9dc0c33ea' },
            { id: '5902cf28-3f1f-435d-b164-08e4d51ce944' },
            { id: '9959665d-557c-42f7-a663-7dba9b467535' },
            { id: 'a552bbdf-8777-4b60-abe3-85f88a0a3b0e' },
            { id: 'd8b70be7-576d-4a8d-ab10-b30576a00037' },
        ],
    },
    {
        '1db7b03d-0ae6-4025-a45e-5369d61fa94a': [
            { id: 'c998cdf8-9e42-4112-89e3-09d07fa454a7' },
            { id: '26206ff9-8cd2-4f34-af95-f083aa74d339' },
            { id: '4da15fb0-baac-4cf9-bca3-af7de054a35a' },
            { id: '2655a736-9aab-468b-93b9-c745d072c34e' },
            { id: '5deb19d4-87a6-4f5a-9605-1eb0217db907' },
            { id: 'eaf87493-0db9-4f15-958a-bfe4d67964a6' },
            { id: 'eedbd8d6-12a0-4e67-aabb-3d87580ef207' },
            { id: '44e2c2fd-0f60-4c71-9e0a-abd867350d48' },
        ],
    },
];
